import React from 'react';
import { useTranslation } from 'react-i18next';

import useModerationContext from '../../../../../../../context/useModerationContext';

import { Message } from '@weezevent/nacre';

const AttendeeRemovedCondition = () => {
    const { t } = useTranslation();
    const [{ flow }] = useModerationContext();

    return (
        <Message
            type={!flow?.allow_removed_attendees ? 'warning' : 'default'}
            title={t(
                `ticket.moderation.statusesTransitions.conditions.detail.conditionRules.attendee-removed.${flow?.allow_removed_attendees ? 'messageTitle' : 'warningMessageTitle'}`
            )}
        >
            {t(
                `ticket.moderation.statusesTransitions.conditions.detail.conditionRules.attendee-removed.${
                    flow?.allow_removed_attendees ? 'messageDescription' : 'warningMessageDescription'
                }`
            )}
        </Message>
    );
};

export default AttendeeRemovedCondition;
